export default "__VITE_ASSET__1ca924c7__"